import type { AlbumSummary, Track } from '@blackblack/shared';
import { formatDuration } from '@blackblack/shared';
import { api } from '../../lib/api';
import { useQuery } from '../../lib/query';
import { Link, useParams } from '../../lib/router';
import { player } from '../../state/player';
import { Button, ErrorState, Skeleton } from '../../components/ui/primitives';
import { Page, PageHeader } from '../../components/layout';
import { Cover } from './Cover';
import { TrackRow } from './TrackRow';
import styles from './music.module.css';

export function AlbumPage() {
  const { id } = useParams<{ id: string }>();
  const q = useQuery<AlbumSummary & { tracks: Track[] }>(`album:${id}`, () => api.get(`/albums/${id}`));
  const a = q.data;
  const total = a?.tracks.reduce((s, t) => s + t.durationSec, 0) ?? 0;

  return (
    <Page>
      <PageHeader title="Album" fallback="/music" />
      {q.error && <ErrorState error={q.error} onRetry={q.refetch} />}
      <div className={styles.collectionHero}>
        {a ? <Cover src={a.coverUrl} size={200} radius={16} /> : <Skeleton w={200} h={200} r={16} />}
        <h1>{a?.title}</h1>
        {a && (
          <p>
            <Link to={`/artist/${a.artist.id}`}>{a.artist.name}</Link> · {a.releaseDate?.slice(0, 4)} · {a.tracks.length} nummers, {formatDuration(total)}
          </p>
        )}
        {a && (
          <div className={styles.collectionActions}>
            <Button icon="play" onClick={() => player.playTracks(a.tracks, 0, a.title)}>
              Afspelen
            </Button>
            <Button
              variant="secondary"
              icon="shuffle"
              onClick={() => {
                if (!player.state.shuffle) player.toggleShuffle();
                player.playTracks(a.tracks, Math.floor(Math.random() * a.tracks.length), a.title);
              }}
            >
              Shuffle
            </Button>
          </div>
        )}
      </div>
      <div className={styles.rows}>{a?.tracks.map((t, i) => <TrackRow key={t.id} track={t} list={a.tracks} index={i} context={a.title} number={i + 1} showCover={false} />)}</div>
    </Page>
  );
}
